import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackPaginationClick } from './tracking';
import { getTermValue, TJsonQuery } from '../../../../packages/JsonQuery';
import { usePaginationActions } from '../../../common/hooks/usePaginationActions';
import { selectJsonQuery } from '../../../common/selectors/filters';
import { ListingDesktopFooter } from '../../components/ListingDesktopFooter';

interface IListingDesktopFooterContainerProps {
  className?: string;
}

export const ListingDesktopFooterContainer: React.FC<IListingDesktopFooterContainerProps> = ({ className }) => {
  const { hasPrev, hasNext, isLoading, handlePrev, handleNext } = usePaginationActions();
  const jsonQuery = useSelector(selectJsonQuery);
  const pageNumber = getTermValue('page')(jsonQuery as TJsonQuery) || 1;

  const onPrevClick = React.useCallback(() => {
    handlePrev();
    trackPaginationClick(pageNumber - 1);
  }, [pageNumber]);

  const onNextClick = React.useCallback(() => {
    handleNext();
    trackPaginationClick(pageNumber + 1);
  }, [pageNumber]);

  return (
    <ListingDesktopFooter
      onPrevClick={onPrevClick}
      onNextClick={onNextClick}
      hasPrev={hasPrev}
      hasNext={hasNext}
      isLoading={isLoading}
      className={className}
    />
  );
};

ListingDesktopFooterContainer.displayName = 'ListingDesktopFooterContainer';
